export var Labels = {
    paymentOptionDivider: 'もしくは',
    cardHolderName: 'カードの名義',
    cardNumber: 'カード番号',
    cardExpiration: '有効期限 (MM/YY)',
    cvv: 'CVV',
    continueButton: '続行'
};
export var FieldErrors = {
    invalidCardHolderName: 'カード名義を入力してください。',
    invalidCreditCardNumber: '有効なクレジットカード番号を入力してください。',
    invalidCardBrand: 'サポートされているカード ブランドを入力してください。',
    invalidExpirationDate: '有効な有効期限を入力してください。',
    invalidCvv: 'CVVコードを入力してください。'
};
